import { api, API } from "@/lib/api";

// ---------- API calls ----------
export const fetchPendingRewards = () =>
  api.get(`/student/rewards/pending`).then((r) => r.data);

export const fetchProgress = () =>
  api.get(`/student/progress`).then((r) => r.data);

export const markClassworkComplete = (chapterId) =>
  api.post(`/student/classwork/${chapterId}/complete`).then((r) => r.data);

export const teacherGetRoster = (sessionId) =>
  api.get(`/teacher/sessions/${sessionId}/roster`).then((r) => r.data);

export const teacherMarkAttendance = (sessionId, presentStudentIds) =>
  api
    .post(`/teacher/sessions/${sessionId}/attendance`, {
      present_student_ids: presentStudentIds,
    })
    .then((r) => r.data);

// ---------- helpers ----------
export const heroImageUrl = `${API}/static/landing_hero.png`;

export const BADGE_LABELS = {
  first_steps: { label: "First Steps", emoji: "🥇" },
  perfect_score: { label: "Perfect Score", emoji: "🎯" },
  on_a_roll: { label: "On a Roll", emoji: "🔥" },
  diamond_streak: { label: "Diamond Streak", emoji: "💎" },
  chapter_champion: { label: "Chapter Champion", emoji: "🎓" },
  course_conqueror: { label: "Course Conqueror", emoji: "🏆" },
  star_student: { label: "Star Student", emoji: "⭐" },
  present: { label: "Present!", emoji: "✋" },
};

// Choose toast copy by event — varied for delight
const COPY = {
  chapter_classwork_completed: [
    "Classwork done! Nice 👏",
    "Boom — chapter learned! 🎉",
  ],
  homework_submitted: [
    "Hurray! Homework in 🎉",
    "Sent off! Your teacher will grade it soon 💪",
    "Yay! Keep it up!",
  ],
  homework_graded_perfect: ["PERFECT! 100% ⭐⭐⭐", "Full marks! 🥇"],
  homework_graded_good: ["Brilliant work 🌟", "Great score! Keep climbing 📈"],
  test_submitted: ["Test submitted! Phew 🧠", "All done — fingers crossed 🤞"],
  test_mcq_perfect: ["MCQ PERFECT! 🎯", "Bullseye on every question! 🎉"],
  test_fully_graded: ["Test fully graded ✨", "See how you did 🌟"],
  attended_class: ["Present! ✋", "Class attended 🎒"],
  streak_3_days: ["3-day streak 🔥", "You're on a roll!"],
  streak_7_days: ["7-day streak 💎 LEGENDARY"],
  first_chapter_completed: ["First chapter done 🎓", "One chapter mastered! 🏅"],
  course_completed: [
    "COURSE COMPLETED 🏆🏆🏆",
    "What a journey — well done!",
  ],
};

export function copyFor(event) {
  const arr = COPY[event] || ["Yay! 🎉"];
  return arr[Math.floor(Math.random() * arr.length)];
}

// What kind of animation to play for each event
export const ANIM_MAP = {
  chapter_classwork_completed: "stars",
  homework_submitted: "toast",
  homework_graded_perfect: "applause",
  homework_graded_good: "stars",
  test_submitted: "toast",
  test_mcq_perfect: "confetti",
  test_fully_graded: "applause",
  attended_class: "stars",
  streak_3_days: "stars",
  streak_7_days: "confetti",
  first_chapter_completed: "confetti",
  course_completed: "confetti",
};
